import { LeasingOffer } from 'common/interfaces';

export const getReferenceLeasingOffer = (leasingOffers: LeasingOffer[]) => {
  return leasingOffers.find(offer => offer.referenceLeasingOffer) || {};
};
